import { render, staticRenderFns } from "./simuladorUsuario.vue?vue&type=template&id=649bdeb9"
import script from "./simuladorUsuario.vue?vue&type=script&lang=js"
export * from "./simuladorUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports